up.compiler('[data-password-toggle]', (element: HTMLInputElement) => {
  const inputGroup = element.closest('.input-group')!
  const button = inputGroup.querySelector('.password-toggle')!
  const icon = inputGroup.querySelector('.icon')!

  function showPassword() {
    element.setAttribute('type', 'text')
    icon.classList.add('-shown')
    icon.classList.remove('-hidden')
  }

  function hidePassword() {
    element.setAttribute('type', 'password')
    icon.classList.add('-hidden')
    icon.classList.remove('-shown')
  }

  function togglePassword() {
    if (element.getAttribute('type') === 'password') {
      showPassword()
    } else {
      hidePassword()
    }
  }

  hidePassword()
  button.addEventListener('click', togglePassword)
})
